import { Box, Button } from "@mui/material";
import React from "react";
import Header from "components/Header";
import Cards from "./Cards";
import SalesAnalytics from "./SalesAnalytics";

const SalesOverview = () => {
  return (
    <div className="">
      <Box m="1.5rem 2.5rem">
        <Header
          title={"Sales"}
          subtitle="Contains data related to sales"
          /*button={
            <Button
              variant="contained"
              size="large"
              className="bg-slate-600 text-gray-50 hover:bg-slate-700"
            >
              Add Expense
            </Button>
          }*/
        />
        <Cards />
        <SalesAnalytics />
      </Box>
    </div>
  );
};

export default SalesOverview;
